import PropTypes from "prop-types"
import React from "react"
import { withTranslation } from "react-i18next"
import { Col, Container, Row } from "reactstrap"

const Footer = ({ t }) => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid>
          <Row>
            <Col md={6}>{new Date().getFullYear()} SenseTek</Col>
            <Col md={6}>
              <div className="text-sm-end d-none d-sm-block">
                {t("DireitosReservados")}
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

Footer.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(Footer)
